import React, { memo } from "react";

import { NoticeIconName, StatusNoticeIconProps } from "../types";

/** Putanje ikona (24 × 24, obrub) za obavijesti uz status. */
const ICON_PATHS: Record<NoticeIconName, string> = {
  edit: "M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z",
  file: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6",
  mail: "M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zM22 6l-10 7L2 6",
  check: "M5 12.5l4.5 4.5L19 7.5",
  euro: "M17 5.5A7 7 0 007 10.5M17 18.5A7 7 0 017 13.5M5 10.5h9M5 13.5h9",
  receipt: "M5 2h14v20l-3-2-2 2-2-2-2 2-2-2-3 2zM9 7h6M9 11h6M9 15h4",
  shield: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM9 12l2 2 4-4",
  x: "M18 6L6 18M6 6l12 12",
};

const StatusNoticeIcon: React.FC<StatusNoticeIconProps> = ({ name, className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={ICON_PATHS[name]} />
    </svg>
  );
};

export default memo(StatusNoticeIcon);
